import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

import {tns} from '../../node_modules/tiny-slider';

var slider = tns({
    mode: 'gallery',
    container: '.slider',
    autoplay: true,
    autoplayButtonOutput: false,
    nav:false,
    controlsText: ["<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-6 w-6\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\">\n" +
    "  <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M15 19l-7-7 7-7\" />\n" +
    "</svg>", "<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-6 w-6\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\">\n" +
    "  <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 5l7 7-7 7\" />\n" +
    "</svg>"],
});